import {
  all,
  call,
  delay,
  put,
  select,
  take,
  debounce,
} from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import {
  dataForObjectIsAccepted,
  dataForObjectIsRejected,
} from '../../actions/userObject/profile/requestFetchUserProfile'
import { fetchObject } from '../../models/Object'
import { getCalendarId } from '../../reducers/bookingCalendar/selectors/calendar'
import { PaymentDictionaryActions } from '../../reducers/paymentDictionary/actionNames'
import { UserProfileActions } from '../../reducers/userObject/actionNames'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'

function* loadObject(action) {
  const calendarId = yield select(getCalendarId)

  if (!calendarId) {
    yield delay(200)
    return yield put(action)
  }

  try {
    const actionNames = fetchActionsName(ActionNames.LoadUserProfile)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, fetchObject)),
    ])

    const object = yield call(service, calendarId)
    yield put(dataForObjectIsAccepted(object))
  } catch (e) {
    yield put(dataForObjectIsRejected(e.message))
  }
}

export default function*() {
  yield debounce(
    500,
    [
      UserProfileActions.RequestDataForUserProfile,
      PaymentDictionaryActions.AcceptedPaymentMethod,
    ],
    loadObject,
  )
}
